import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const listFeedback = createAsyncThunk(
  "feedback/list",
  async (formInfo, { rejectWithValue }) => {
    try {
      const startAt = formInfo?.start_at ?? 0;
      const maxResults = formInfo?.max_results ?? 20;
      const res = await api.get(
        `user/feedback?start_at=${startAt}&max_results=${maxResults}`
      );
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getFeedback = createAsyncThunk(
  "feedback/get",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { issue_key } = formInfo;
      const res = await api.get(`user/feedback/${issue_key}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const addFeedbackComment = createAsyncThunk(
  "feedback/addComment",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { issue_key, body } = formInfo;
      const res = await api.post(`user/feedback/${issue_key}/comment`, { body });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const cancelFeedback = createAsyncThunk(
  "feedback/cancel",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { issue_key } = formInfo;
      const res = await api.post(`user/feedback/${issue_key}/cancel`, {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
